export const featuredCards = [
  {
    id: 'card-1',
    type: 'dark' as const,
    icon: '🔥',
    title: '网红黑料',
    description: '最新网红塌房事件全记录，从聊天记录到视频实锤，一条龙吃瓜体验。',
  },
  {
    id: 'card-2',
    type: 'image' as const,
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20celebrity%20gossip%20magazine%20cover%20style%20with%20dramatic%20lighting%20and%20candid%20paparazzi%20aesthetic%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20editorial%20photography%20with%20glamorous%20yet%20scandalous%20mood%2C%20soft%20bokeh%20background%2C%20high%20contrast%20composition&width=600&height=400&seq=feature-card-02&orientation=landscape',
    category: '明星八卦',
    title: '娱乐圈最新大瓜',
  },
  {
    id: 'card-3',
    type: 'text-image' as const,
    title: '吃瓜大赛',
    description: '每日精选最劲爆的瓜，网友投票选出本周瓜王，参与互动赢好礼。',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20trending%20topic%20visualization%20with%20vibrant%20comment%20threads%20and%20viral%20content%20aesthetic%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20modern%20flat%20design%20with%20playful%20elements%2C%20clean%20minimal%20composition%20with%20chat%20bubbles&width=600&height=400&seq=feature-card-03&orientation=landscape',
  },
];

export const hotArticles = [
  {
    id: 1,
    title: '某千万粉丝网红被曝私下辱骂粉丝，聊天记录流出引众怒',
    summary: '一段疑似某知名网红与助理的聊天记录近日在网络上疯传，内容涉及对粉丝群体的不当言论...',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20dramatic%20chat%20messages%20with%20red%20highlighted%20text%20on%20dark%20background%2C%20mysterious%20atmosphere%20with%20soft%20warm%20ambient%20lighting%2C%20digital%20privacy%20concept%2C%20editorial%20tech%20photography&width=400&height=300&seq=hot-article-01&orientation=landscape',
    category: '网红爆料',
    date: '2026-07-06',
    views: 128000,
  },
  {
    id: 2,
    title: '某女星深夜密会神秘男子，酒店共度8小时被拍实锤',
    summary: '狗仔队近日蹲守某高档酒店，拍到知名女星与一神秘男子前后进入酒店，直至次日清晨才离开...',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20dramatic%20paparazzi%20style%20photography%2C%20warm%20golden%20lighting%20spilling%20from%20lobby%2C%20mysterious%20silhouette%20walking%20through%20revolving%20door%2C%20cinematic%20noir%20atmosphere%2C%20soft%20streetlight%20glow&width=400&height=300&seq=hot-article-02&orientation=landscape',
    category: '明星八卦',
    date: '2026-07-06',
    views: 256000,
  },
  {
    id: 3,
    title: '知名主播直播带货翻车，假货风波持续发酵品牌方紧急回应',
    summary: '某平台头部主播近日被消费者举报售卖假冒化妆品，直播间当场被网友截图取证...',
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20dramatic%20red%20and%20warning%20sign%20overlay%2C%20product%20display%20with%20question%20marks%2C%20broadcasting%20equipment%20in%20warm%20studio%20lighting%2C%20tense%20atmosphere%2C%20editorial%20style&width=400&height=300&seq=hot-article-03&orientation=landscape',
    category: '吃瓜大赛',
    date: '2026-07-05',
    views: 189000,
  },
  {
    id: 4,
    title: '某综艺节目后台冲突曝光，两位嘉宾录制现场大打出手',
    summary: '据现场工作人员爆料，某热门综艺录制过程中两位嘉宾因游戏环节发生激烈争执...',
    image: 'https://readdy.ai/api/search-image?query=TV%20show%20studio%20backstage%20dramatic%20moment%20with%20tension%20between%20two%20silhouettes%2C%20warm%20spotlight%20and%20deep%20shadows%2C%20behind%20the%20scenes%20atmosphere%2C%20cinematic%20lighting%20with%20dramatic%20mood%2C%20editorial%20photography&width=400&height=300&seq=hot-article-04&orientation=landscape',
    category: '明星八卦',
    date: '2026-07-05',
    views: 312000,
  },
  {
    id: 5,
    title: '网红情侣突然官宣分手，男方被扒出轨多名女粉丝',
    summary: '一直以恩爱示人的某网红情侣今日同时发布分手声明，随后网友扒出男方多段暧昧聊天记录...',
    image: 'https://readdy.ai/api/search-image?query=Broken%20heart%20concept%20with%20cracked%20phone%20screen%20showing%20social%20media%20breakup%20post%2C%20warm%20dramatic%20side%20lighting%2C%20emotional%20atmosphere%2C%20soft%20bokeh%20background%20in%20coral%20tones%2C%20editorial%20minimalist%20style&width=400&height=300&seq=hot-article-05&orientation=landscape',
    category: '网红爆料',
    date: '2026-07-04',
    views: 445000,
  },
  {
    id: 6,
    title: '某顶流男团成员被曝校园霸凌黑历史，昔日同学集体发声',
    summary: '随着该男团人气飙升，多名自称是其昔日同学的网友在社交平台联合爆料其校园时期的霸凌行为...',
    image: 'https://readdy.ai/api/search-image?query=Yearbook%20style%20photo%20with%20mysterious%20redacted%20faces%20and%20dramatic%20lighting%2C%20nostalgic%20school%20corridor%20background%2C%20warm%20amber%20tones%20with%20deep%20shadows%2C%20investigative%20journalism%20aesthetic%2C%20cinematic%20mood&width=400&height=300&seq=hot-article-06&orientation=landscape',
    category: '明星八卦',
    date: '2026-07-04',
    views: 378000,
  },
];

export const userComments = [
  {
    id: 1,
    name: '吃瓜不嫌事大',
    handle: '@chigua_dalao',
    avatar: 'C',
    comment: '这瓜保熟吗？我看聊天记录那个时间线根本对不上，感觉是有人在故意搞事情。不过这个网红平时就很高调，得罪人也是迟早的事。',
    likes: 3420,
  },
  {
    id: 2,
    name: '娱乐圈观察员',
    handle: '@yule_observer',
    avatar: 'Y',
    comment: '终于有人爆出来了！我在这个圈子混了五年，早就听说过这位的一些事情，只是一直没人敢说。这次应该是得罪了不该得罪的人。',
    likes: 2891,
  },
  {
    id: 3,
    name: '理性吃瓜人',
    handle: '@lixing_chi',
    avatar: 'L',
    comment: '建议大家冷静一下，目前只有聊天截图，没有其他实锤。如果真的有问题，相信会有更多证据浮出水面。不要急着站队。',
    likes: 1567,
  },
  {
    id: 4,
    name: '深夜吃瓜群众',
    handle: '@shenye_gua',
    avatar: 'S',
    comment: '我艹这个瓜我吃了三天了！每天都有新进展，比追剧还精彩。那个助理反转又反转的，我已经不知道该信谁了。',
    likes: 4230,
  },
  {
    id: 5,
    name: '八卦小能手',
    handle: '@bagua_master',
    avatar: 'B',
    comment: '作为一个专业吃瓜十年的老饕，我可以负责任地说，这个瓜的质量属于上乘。时间线清晰，人物关系完整，还有第三方佐证。五星好评！',
    likes: 5102,
  },
  {
    id: 6,
    name: '真相挖掘机',
    handle: '@zhenxiang_jueji',
    avatar: 'Z',
    comment: '给大家补充一个冷知识：这位网红去年就和那家公司解约了，据说就是因为类似的问题。老粉应该还记得当时她突然停播了一个月吧？',
    likes: 3876,
  },
];

export const stats = [
  { value: '12,000+', label: '累计爆料' },
  { value: '580万', label: '月活用户' },
  { value: '3,200+', label: '独家内容' },
  { value: '99.9%', label: '在线率' },
];